// extracted by mini-css-extract-plugin
export var bounce = "_op-1";
export var generatingText = "_op-6";
export var lightning = "_op-4";
export var popup = "_op-5";
export var progressBar = "_op-7";
export var progressFill = "_op-8";
export var progressShimmer = "_op-9";
export var progressText = "_op-a";
export var shimmer = "_op-3";
export var uploadIcon = "_op-0";
export var uploadingText = "_op-2";